// frontend-web/src/pages/Admin/AddQuestionsToMegaExam.jsx

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function AddQuestionsToMegaExam() {
  const { examId } = useParams();
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [subjectWiseQuestions, setSubjectWiseQuestions] = useState({});
  const [subjectLimits, setSubjectLimits] = useState({});
  const [activeSubject, setActiveSubject] = useState(null);
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [loading, setLoading] = useState(true);

  const nav = useNavigate();

  useEffect(() => {
    loadData();
  }, [examId]);

  const loadData = async () => {
    try {
      const [examRes, quesRes] = await Promise.all([
        api.get(`/admin/mega_scholarship/${examId}`),
        api.get(`/admin/questions/for-mega-exam/${examId}`)
      ]);

      const examData = examRes.data;
      const allQuestions = quesRes.data || [];

      // subject limits from backend
      setSubjectLimits(examData.question_count || {});

      // group questions by subject
      const grouped = allQuestions.reduce((acc, q) => {
        acc[q.subject_id] = acc[q.subject_id] || [];
        acc[q.subject_id].push(q);
        return acc;
      }, {});

      setSubjectWiseQuestions(grouped);
      setQuestions(allQuestions);
      setExam(examData);

      // set first subject active automatically
      const firstSubject = Object.keys(grouped)[0];
      setActiveSubject(firstSubject);

    } catch (err) {
      alert("Load nahi ho raha: " + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (subjectId, qid) => {
    setSelectedQuestions((prev) => {
      const existing = prev[subjectId] || [];

      if (existing.includes(qid)) {
        return { ...prev, [subjectId]: existing.filter((id) => id !== qid) };
      }

      if (existing.length >= subjectLimits[subjectId]) return prev;

      return { ...prev, [subjectId]: [...existing, qid] };
    });
  };

  const totalCompleted = Object.keys(subjectLimits).every((s) => 
    selectedQuestions[s]?.length === subjectLimits[s]
  );

  const handleSave = async () => {
    const finalSelected = Object.values(selectedQuestions).flat();

    if (!totalCompleted) {
      return alert("Har subject ke required questions complete karo!");
    }

    try {
      await api.post(`/admin/mega_scholarship/${examId}/add-questions`, {
        question_ids: finalSelected
      });

      alert("🎉 Exam Questions Saved Successfully!");
      nav("/admin/mega-scholarship-list");
    } catch (err) {
      alert("Save nahi hua: " + (err.response?.data?.error || "Error"));
    }
  };

  if (loading) return <div style={{ color: "white", padding: 40 }}>Loading...</div>;

  return (
    <div style={{ padding: 40, background: "#0f172a", color: "white", minHeight: "100vh" }}>
      <h1 style={{ fontSize: 32 }}>Add Questions - {exam?.title}</h1>

      <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
        {Object.keys(subjectWiseQuestions).map((subId) => (
          <button
            key={subId}
            onClick={() => setActiveSubject(subId)}
            style={{
              padding: "10px 18px",
              borderRadius: 10,
              cursor: "pointer",
              background: activeSubject == subId ? "#f59e0b" : "#1e293b",
              border: "1px solid #475569",
              color: "white",
              fontSize: 16,
              fontWeight: 600
            }}
          >
            {subjectWiseQuestions[subId][0]?.subject_name} ({selectedQuestions[subId]?.length || 0}/{subjectLimits[subId]})
          </button>
        ))}
      </div>

      <hr style={{ marginTop: 20, opacity: 0.3 }} />

      <div style={{ marginTop: 30, display: "grid", gap: 12 }}>
        {(subjectWiseQuestions[activeSubject] || []).map((q) => {
          const selected = selectedQuestions[activeSubject]?.includes(q.id);
          const disabled =
            !selected &&
            selectedQuestions[activeSubject]?.length >= subjectLimits[activeSubject];

          return (
            <label
              key={q.id}
              onClick={() => !disabled && toggleQuestion(activeSubject, q.id)}
              style={{
                display: "block",
                padding: "16px 20px",
                background: selected ? "#f59e0b" : "#1e293b",
                borderRadius: 12,
                cursor: disabled ? "not-allowed" : "pointer",
                border: "2px solid #475569"
              }}
            >
              <input
                type="checkbox"
                checked={selected}
                readOnly
                style={{ marginRight: 16 }}
              />
              {q.text.substring(0, 120)}...
            </label>
          );
        })}
      </div>

      <button
        onClick={handleSave}
        disabled={!totalCompleted}
        style={{
          marginTop: 30,
          padding: "16px 48px",
          background: totalCompleted ? "#f59e0b" : "gray",
          color: "white",
          border: "none",
          borderRadius: 12,
          fontSize: 18,
          cursor: totalCompleted ? "pointer" : "not-allowed"
        }}
      >
        Save Questions & Complete Exam
      </button>
    </div>
  );
}
